import type { UsuarioSessao } from "../types/auth";
import type { ConfiguracoesSistemaPublicas } from "../utils/configuracoesSistema";
import { menu } from "../layout/navegacao";
import { filtrarMenuAcessivel } from "../layout/menuAcesso";
import { usuarioTemAcessoTela } from "../utils/permissoes";

/**
 * Rota de pouso do usuario logado: a Visao Geral padrao ("/") para quem tem
 * acesso a ela (dono da organizacao/ADMIN_ORG sempre cai aqui — ver
 * usuarioTemAcessoTela), ou a entrada do modulo do perfil dele. Na ordem do
 * menu, prioriza a Visao Geral de cada modulo; modulos sem dashboard usam suas
 * telas operacionais: Financeiro abre o Fluxo de Caixa, Suporte abre Chamados
 * e Produção abre a Lista de produção.
 * Sem essas entradas, usa a primeira tela
 * acessivel. Retorna null quando o perfil nao tem nenhuma tela liberada.
 */
export function calcularRotaInicial(
  usuario: UsuarioSessao | null | undefined,
  configuracoes: Pick<ConfiguracoesSistemaPublicas, "modulosAtivos">
): string | null {
  if (usuarioTemAcessoTela(usuario, "visao-geral")) return "/";

  const menuAcessivel = filtrarMenuAcessivel(menu, configuracoes, usuario)
    .map((item) =>
      item.subitens ? { ...item, subitens: item.subitens.filter((sub) => !sub.bloqueado) } : item
    )
    .filter((item) => (item.subitens ? item.subitens.length > 0 : !item.bloqueado));

  const primeiro = menuAcessivel[0];
  if (!primeiro) return null;

  for (const item of menuAcessivel) {
    const entradaModulo = item.subitens?.find((sub) => ["/vendas", "/compras", "/fornecedor/pedidos", "/estoque/saldo", "/financeiro/fluxo-caixa-diario-mensal", "/suporte", "/producao/lista"].includes(sub.rota) || sub.rota.endsWith("/visao-geral"));
    if (entradaModulo) return entradaModulo.rota;
  }

  return primeiro.subitens ? primeiro.subitens[0].rota : (primeiro.rota ?? null);
}
